import React, { useState } from "react";
import {
  FaExclamationCircle,
  FaCheckCircle,
  FaRegTimesCircle,
} from "react-icons/fa";
import {
  HiOutlineExternalLink,
  HiOutlineDocumentReport,
  HiOutlineClipboardList,
  HiOutlineLibrary,
  HiOutlinePencilAlt,
  HiOutlineTrash,
  HiOutlineOfficeBuilding,
  HiOutlineCash,
  HiOutlineEye,
  HiStar,
  HiOutlineStar,
  HiOutlineSparkles,
  HiOutlineChatAlt2,
} from "react-icons/hi";
import { eliminarLicitacion, exportarExcel, toggleFavorito } from "../api";
import { toast } from "react-toastify";
import ModalDocumento from "./ModalDocumento";
import ModalEditarLicitacion from "./ModalEditarLicitacion";
import ModalConfirmacion from "./ModalConfirmacion";
import InformeResumen from "./InformeResumen";
import Costes from "./Costes";
import DetalleCostesIndirectos from "./CostesIndirectos";
import PanelIA from "./PanelIA";
import "../styles.css";

function obtenerEnlacePrincipal(licitacion) {
  let enlace = null;
  const raw = licitacion.enlaces;
  if (Array.isArray(raw)) {
    const items = raw
      .filter((s) => s?.trim())
      .flatMap((s) => {
        const results = [];
        const regex = /\[?([^\]]+)\]\(([^)"]+)\)/g;
        let m;
        while ((m = regex.exec(s)) !== null)
          results.push({ tipo: m[1].trim(), url: m[2].trim() });
        return results.length ? results : [{ tipo: "Documento", url: s }];
      });
    const encontrado = items.find((i) =>
      i.tipo.toLowerCase().includes("anuncio")
    );
    if (encontrado) enlace = encontrado.url;
    else if (items.length > 0) enlace = items[0].url;
  } else if (typeof raw === "string" && raw.trim()) {
    const items = raw
      .split("|")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    const encontrado = items.find((i) => i.toLowerCase().includes("anuncio"));
    if (encontrado) {
      const parts = encontrado.split(";");
      enlace = parts.length > 1 ? parts[1].trim() : parts[0].trim();
    } else if (items.length > 0) {
      const parts = items[0].split(";");
      enlace = parts.length > 1 ? parts[1].trim() : parts[0].trim();
    }
  }
  return enlace;
}

function LicitacionCard({
  licitacion,
  seleccionada = false,
  onSelect,
  onEliminar,
  onActualizar,
  usuario,
  onActualizarGlobal,
}) {
  const [expandido, setExpandido] = useState(false);
  const [modalDocsOpen, setModalDocsOpen] = useState(false);
  const [showConfirmEliminar, setShowConfirmEliminar] = useState(false);
  const [modalEditarOpen, setModalEditarOpen] = useState(false);
  const [activeEstudio, setActiveEstudio] = useState(null);
  const [tabIA, setTabIA] = useState("resumen");

  const esAdmin = usuario?.rol?.rol
    ? usuario.rol.rol === "admin"
    : usuario?.rol === "admin";

  const handleAbrirIA = (e, tab = "resumen") => {
    if (e && e.stopPropagation) e.stopPropagation();
    setExpandido(true);
    setTabIA(tab);
    if (activeEstudio === "ia" && tabIA === tab) {
      setActiveEstudio(null);
    } else {
      setActiveEstudio("ia");
    }
  };

  const handleClick = () => {
    setExpandido(!expandido);
    if (typeof onSelect === "function") onSelect();
  };

  const handleEliminar = async () => {
    if (!esAdmin) return;
    try {
      await eliminarLicitacion(licitacion.numero_expediente);
      toast.success("Licitación eliminada");
      if (typeof onActualizar === "function") onActualizar();
      setShowConfirmEliminar(false);
    } catch (error) {
      toast.error("Error al eliminar: " + error.message);
      console.error(error);
    }
  };

  const handleToggleFavorito = async (e) => {
    e.stopPropagation();
    try {
      const result = await toggleFavorito(licitacion.numero_expediente);
      if (result.favorito) {
        toast.info("Añadido a favoritos", { icon: "⭐" });
      }
      if (typeof onActualizar === "function") onActualizar();
      if (typeof onActualizarGlobal === "function") onActualizarGlobal();
    } catch (error) {
      toast.error("Error al marcar favorito: " + error.message);
    }
  };

  const hoy = new Date();
  const fecha = licitacion.fecha_presentacion
    ? new Date(licitacion.fecha_presentacion)
    : null;
  const diasRestantes = fecha
    ? Math.ceil((fecha - hoy) / (1000 * 60 * 60 * 24))
    : null;

  let estadoVisual = licitacion.estado?.toLowerCase() || "pendiente";
  let icono = null;

  const hoyNormalizado = new Date();
  hoyNormalizado.setHours(0, 0, 0, 0);
  const fechaNormalizada = fecha ? new Date(fecha) : null;
  if (fechaNormalizada) fechaNormalizada.setHours(0, 0, 0, 0);

  if (
    estadoVisual !== "presentada" &&
    estadoVisual !== "adjudicada" &&
    estadoVisual !== "no adjudicada" &&
    fechaNormalizada &&
    fechaNormalizada < hoyNormalizado
  ) {
    estadoVisual = "cerrada";
    icono = (
      <FaRegTimesCircle
        style={{ color: "gray", marginLeft: 8 }}
        title="Cerrada"
      />
    );
  } else if (
    estadoVisual !== "presentada" &&
    estadoVisual !== "adjudicada" &&
    estadoVisual !== "no adjudicada" &&
    fechaNormalizada &&
    fechaNormalizada.getTime() === hoyNormalizado.getTime()
  ) {
    estadoVisual = "cierra hoy";
    icono = (
      <FaExclamationCircle
        className="pulse-animation"
        style={{ color: "#ef4444", marginLeft: 8 }}
        title="CIERRA HOY"
      />
    );
  } else if (
    estadoVisual === "pendiente" &&
    diasRestantes !== null &&
    diasRestantes <= 7
  ) {
    estadoVisual = "proxima";
    icono = (
      <FaExclamationCircle
        style={{ color: "red", marginLeft: 8 }}
        title="Próxima a vencer"
      />
    );
  } else if (estadoVisual === "presentada") {
    icono = (
      <FaCheckCircle
        style={{ color: "green", marginLeft: 8 }}
        title="Presentada"
      />
    );
  } else if (estadoVisual === "adjudicada") {
    icono = (
      <FaCheckCircle
        style={{ color: "blue", marginLeft: 8 }}
        title="Adjudicada"
      />
    );
  } else if (estadoVisual === "no adjudicada") {
    icono = (
      <FaRegTimesCircle
        style={{ color: "gray", marginLeft: 8 }}
        title="No adjudicada"
      />
    );
  }

  const formatearFecha = (fechaObj) => {
    if (!fechaObj) return "-";
    const d = new Date(fechaObj);
    return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${d.getFullYear()}`;
  };

  const formatearPresupuesto = (valor) => {
    if (valor == null) return "-";
    return (
      new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valor) + " €"
    );
  };

  const filaClases = [
    "fila-licitacion",
    seleccionada ? "seleccionada" : "",
  ].join(" ");

  const estadoClase = `col-estado estado-${estadoVisual.replace(/\s+/g, "-")}`;

  const estadoMostrar =
    estadoVisual.toLowerCase() === "pendiente"
      ? "En curso"
      : estadoVisual.charAt(0).toUpperCase() + estadoVisual.slice(1);

  return (
    <>
      <div className="licitacion-card">
        <div className={filaClases} onClick={handleClick}>
          <div className="col-expediente" title={licitacion.numero_expediente?.toUpperCase()}>
            {(() => {
              const ref = (licitacion.numero_expediente || "").toUpperCase();
              return ref.length > 20 ? ref.slice(0, 20) + "…" : ref;
            })()}
          </div>
          <div className="col-titulo" title={licitacion.titulo}>
            {licitacion.titulo}
          </div>
          <div className="col-organismo" title={licitacion.organismo}>
            {licitacion.organismo}
          </div>
          <div className="col-presupuesto">
            {formatearPresupuesto(licitacion.presupuesto)}
          </div>
          <div className="col-fecha">
            {formatearFecha(licitacion.fecha_presentacion)}
          </div>
          <div className="col-estado-container">
            <span className={estadoClase}>{estadoMostrar}</span>
          </div>
          <div className="col-boton">
            <button
              className={`btn-favorito ${
                licitacion.favorito ? "es-favorito" : ""
              }`}
              onClick={handleToggleFavorito}
              title={
                licitacion.favorito
                  ? "Quitar de favoritos"
                  : "Marcar como favorito"
              }
            >
              {licitacion.favorito ? (
                <HiStar size={22} />
              ) : (
                <HiOutlineStar size={22} />
              )}
            </button>
          </div>
        </div>

        {expandido && (
          <div className="detalle-licitacion animate-fadeIn">
            <div className="info-grid">
              <div className="info-item">
                <label>Expediente</label>
                <span>{licitacion.numero_expediente.toUpperCase()}</span>
              </div>
              <div className="info-item">
                <label>BOE</label>
                <span>{formatearFecha(licitacion.boe)}</span>
              </div>
              <div className="info-item">
                <label>Ámbito</label>
                <span>{licitacion.ambito || "-"}</span>
              </div>
              <div className="info-item">
                <label>Presupuesto (SIN IVA)</label>
                <span className="presupuesto-highlight">
                  {formatearPresupuesto(licitacion.presupuesto)}
                </span>
              </div>
              <div className="info-item">
                <label>País</label>
                <span>{licitacion.pais || "-"}</span>
              </div>
              <div className="info-item">
                <label>Fecha Límite</label>
                <span>{formatearFecha(licitacion.fecha_presentacion)}</span>
              </div>
              <div className="info-item full-width">
                <label>Título / Descripción</label>
                <span>{licitacion.titulo || "-"}</span>
              </div>
              <div className="info-item full-width">
                <label>Observaciones / Garantía</label>
                <span>{licitacion.observaciones || "-"}</span>
              </div>
            </div>

            <div className="detalle-sections">
              <div className="section-enlaces">
                <label>
                  <HiOutlineExternalLink /> Enlaces de Interés
                </label>
                <div className="enlaces-list">
                  {(() => {
                    const raw = licitacion.enlaces;
                    let items = [];
                    if (Array.isArray(raw)) {
                      items = raw
                        .filter((s) => s?.trim())
                        .flatMap((s) => {
                          const results = [];
                          const regex = /\[?([^\]]+)\]\(([^)"]+)\)/g;
                          let m;
                          while ((m = regex.exec(s)) !== null)
                            results.push(`${m[1].trim()};${m[2].trim()}`);
                          return results.length ? results : [s];
                        });
                    } else if (typeof raw === "string" && raw.trim()) {
                      items = raw
                        .split("|")
                        .map((s) => s.trim())
                        .filter((s) => s.length > 0);
                    }

                    if (!items.length)
                      return (
                        <span className="no-data">
                          No hay enlaces disponibles
                        </span>
                      );

                    return items.map((item, idx) => {
                      const [tipoRaw, urlRaw] = String(item).split(";", 2);
                      const tipo = tipoRaw.trim() || "Documento";
                      const url = urlRaw?.trim();
                      if (!url) return null;
                      return (
                        <a
                          key={idx}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="enlace-card"
                        >
                          <HiOutlineExternalLink /> {tipo}
                        </a>
                      );
                    });
                  })()}
                </div>
              </div>

              <div className="section-acciones">
                <label>
                  <HiOutlineDocumentReport /> Estudios y Análisis
                </label>
                <div className="botones-acciones-estudio">
                  <button
                    className={`btn-estudio ${
                      activeEstudio === "resumen" ? "active-estudio-btn" : ""
                    }`}
                    onClick={() =>
                      setActiveEstudio(
                        activeEstudio === "resumen" ? null : "resumen"
                      )
                    }
                  >
                    <HiOutlineClipboardList /> Resumen Oferta
                  </button>
                  <button
                    className={`btn-estudio ${
                      activeEstudio === "costes" ? "active-estudio-btn" : ""
                    }`}
                    onClick={() =>
                      setActiveEstudio(
                        activeEstudio === "costes" ? null : "costes"
                      )
                    }
                  >
                    <HiOutlineCash /> Control de Costes
                  </button>
                  <button
                    className={`btn-estudio ${
                      activeEstudio === "detalles" ? "active-estudio-btn" : ""
                    }`}
                    onClick={() =>
                      setActiveEstudio(
                        activeEstudio === "detalles" ? null : "detalles"
                      )
                    }
                  >
                    <HiOutlineOfficeBuilding /> Costes Indirectos
                  </button>
                  <button
                    className="btn-estudio highlight"
                    onClick={(e) => {
                      e.stopPropagation();
                      exportarExcel(licitacion.numero_expediente);
                    }}
                  >
                    <HiOutlineExternalLink /> Exportar Excel
                  </button>
                </div>
              </div>

              <div className="section-gestion">
                <label>
                  <HiOutlineLibrary /> Gestión Documental e IA
                </label>
                <div className="botones-acciones-gestion">
                  <button
                    className="btn-gestion"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalDocsOpen(true);
                    }}
                  >
                    <HiOutlineEye /> Documentos
                  </button>
                  <button
                    className={`btn-gestion btn-ia-sparkle ${
                      activeEstudio === "ia" && tabIA === "resumen"
                        ? "activo"
                        : ""
                    }`}
                    onClick={(e) => handleAbrirIA(e, "resumen")}
                    title="Abrir Visor de Resumen IA (desde documentos locales o portal web)"
                  >
                    <HiOutlineSparkles size={17} /> Resumen IA
                  </button>
                  <button
                    className={`btn-gestion btn-ia-chat ${
                      activeEstudio === "ia" && tabIA === "chat" ? "activo" : ""
                    }`}
                    onClick={(e) => handleAbrirIA(e, "chat")}
                    title="Chatear y hacer preguntas sobre los pliegos"
                  >
                    <HiOutlineChatAlt2 size={17} /> Chat Pliegos
                  </button>
                  {esAdmin && (
                    <>
                      <button
                        className="btn-gestion warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalEditarOpen(true);
                        }}
                      >
                        <HiOutlinePencilAlt /> Editar
                      </button>
                      <button
                        className="btn-gestion danger"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowConfirmEliminar(true);
                        }}
                      >
                        <HiOutlineTrash /> Eliminar
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

            {activeEstudio && (
              <div className="estudio-container animate-fadeIn">
                {activeEstudio === "resumen" && (
                  <InformeResumen
                    numeroExpediente={licitacion.numero_expediente}
                    onCerrar={() => setActiveEstudio(null)}
                  />
                )}
                {activeEstudio === "costes" && (
                  <Costes
                    numeroExpediente={licitacion.numero_expediente}
                    onCerrar={() => setActiveEstudio(null)}
                  />
                )}
                {activeEstudio === "detalles" && (
                  <DetalleCostesIndirectos
                    numeroExpediente={licitacion.numero_expediente}
                    onCerrar={() => setActiveEstudio(null)}
                  />
                )}
                {activeEstudio === "ia" && (
                  <PanelIA
                    numeroExpediente={licitacion.numero_expediente}
                    enlaceDefecto={obtenerEnlacePrincipal(licitacion)}
                    tabInicial={tabIA}
                    onCerrar={() => setActiveEstudio(null)}
                    onActualizarDocumentos={onActualizar}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <ModalConfirmacion
        visible={showConfirmEliminar}
        titulo="Eliminar Licitación"
        mensaje={`¿Estás seguro de que deseas eliminar permanentemente la licitación ${licitacion.numero_expediente}? Esta acción no se puede deshacer.`}
        tipo="rojo"
        onConfirmar={handleEliminar}
        onCancelar={() => setShowConfirmEliminar(false)}
      />

      {modalDocsOpen && (
        <ModalDocumento
          numero={licitacion.numero_expediente}
          onClose={() => setModalDocsOpen(false)}
          usuario={usuario}
          onAbrirPanelIA={(tab) => {
            setExpandido(true);
            setTabIA(tab || "resumen");
            setActiveEstudio("ia");
          }}
        />
      )}
      {modalEditarOpen && (
        <ModalEditarLicitacion
          numero={licitacion.numero_expediente}
          onClose={() => setModalEditarOpen(false)}
          onActualizar={onActualizar}
        />
      )}
    </>
  );
}

export default LicitacionCard;
